import { LoadingOutlined } from '@ant-design/icons';
import { Button, Form, Input, message } from 'antd';
import { get, trim } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { SILA_FAILURE } from './apollo_queries';
import Editor from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { UPDATE_SILA_FAILURE } from './apollo_mutations';

const FormItem = Form.Item;

export function SilaFailureDetails() {
  const match = useRouteMatch();
  const history = useHistory();
  const silaFailureId = get(match, 'params.id', '');
  const { data, error, loading } = useQuery(SILA_FAILURE, {
    variables: { id: silaFailureId },
  });
  const [update, updateData] = useMutation(UPDATE_SILA_FAILURE);

  const { rawTag, instruction, requirements, type } = get(
    data,
    'silaFailure',
    {}
  );

  const [instructionLocal, setInstructionLocal] = useState('');
  const [requirementsLocal, setRequirementsLocal] = useState('');

  useEffect(() => {
    if (instruction) {
      setInstructionLocal(instruction);
    }
  }, [instruction]);

  useEffect(() => {
    if (requirements) {
      setRequirementsLocal(requirements);
    }
  }, [requirements]);

  if (loading) {
    return (
      <div className="web-load-wrap">
        <LoadingOutlined />
      </div>
    );
  }

  if (error) {
    return (
      <div className="web-chat__main-content wc__solo">
        Error, please refresh page or check your internet connection. If error
        persists contact JC
      </div>
    );
  }

  return (
    <div className="web-chat__main-content">
      <div className="tr__header">
        <div className="top_header">
          <div style={{ fontWeight: 'bolder' }} className="sub-text">
            {rawTag}
          </div>
        </div>
        <div className="tr__b">
          <Button
            style={{ marginLeft: 10 }}
            role="button"
            onClick={() => history.push('/')}
            type="primary"
            danger
          >
            Back
          </Button>
        </div>
      </div>
      <div className="creating">
        <div className="create-b b-n b-r m-c">
          <div style={{ background: 'white' }}>
            <Form
              initialValues={{ type, rawTag }}
              labelCol={{ span: 3 }}
              wrapperCol={{ span: 20 }}
              onFinish={async (values) => {
                try {
                  const data = { ...values };
                  data['id'] = silaFailureId;

                  if (instructionLocal) {
                    data['instruction'] = instructionLocal;
                  }

                  if (requirementsLocal) {
                    data['requirements'] = requirementsLocal;
                  }

                  if (values.rawTag) {
                    const formattedTag = trim(values.rawTag)
                      .replace(/\s/g, '-')
                      .toLowerCase();
                    data.formattedTag = formattedTag;
                  }

                  const resp = await update({ variables: { data } });

                  if (resp && resp.data) {
                    message.success('Sucess');
                  }
                } catch (error) {
                  message.error(error.message);
                }
              }}
            >
              <FormItem name="rawTag" label="Title" required>
                <Input name="rawTag" placeholder="Failure title" required />
              </FormItem>
              <FormItem name="type" label="Type" required>
                <Input name="type" placeholder="Sila type" required />
              </FormItem>
              <FormItem label="Instruction to client">
                <Editor
                  theme="snow"
                  value={instructionLocal}
                  onChange={setInstructionLocal}
                />
              </FormItem>
              <FormItem label="Requirements">
                <Editor
                  theme="snow"
                  value={requirementsLocal}
                  onChange={setRequirementsLocal}
                />
              </FormItem>
              <FormItem label="Action">
                <Button
                  type="primary"
                  htmlType="submit"
                  style={{ marginRight: 8 }}
                  disabled={updateData.loading}
                >
                  Update
                </Button>
              </FormItem>
            </Form>
          </div>
        </div>
      </div>
    </div>
  );
}
